var map = {
	"./Alison.png": 8210,
	"./Avatar.png": 7181,
	"./TRON.png": 7795,
	"./TotalReward.png": 1695,
	"./USDT.png": 3226,
	"./add.png": 2177,
	"./arrow-circle-broken-down.png": 7209,
	"./arrow-circle-broken-up.png": 10,
	"./arrow_right.png": 6556,
	"./arrow_up.png": 2395,
	"./back.png": 8887,
	"./backdrop-filter.png": 1473,
	"./cashback.png": 9250,
	"./checked.png": 6903,
	"./coin.png": 3049,
	"./coinGaming.png": 5390,
	"./coin_back.png": 5647,
	"./coins-hand.png": 1234,
	"./coins-stacked-02.png": 7147,
	"./coins-stacked.png": 2590,
	"./copy.png": 5717,
	"./day.png": 6622,
	"./del.png": 7055,
	"./discovery.png": 3170,
	"./exit.png": 8066,
	"./language.png": 2284,
	"./logo.png": 175,
	"./logo_small.png": 4691,
	"./more.png": 7057,
	"./more2.png": 7655,
	"./omit.png": 9361,
	"./pie-chart.png": 2957,
	"./rec.png": 4898,
	"./record.png": 2397,
	"./refresh.png": 1641,
	"./refresh_white.png": 5215,
	"./search.png": 4562,
	"./slider_l.png": 5248,
	"./slider_o.png": 3579,
	"./sub.png": 1094,
	"./tick.png": 7365,
	"./trophies.png": 3520,
	"./unchecked.png": 3076,
	"./user.png": 5851,
	"./uu.png": 9004,
	"./wait.png": 6141,
	"./wallet.png": 2897,
	"./warn.png": 8434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 393;